import { SvgIconProps } from "@mui/material";
import { FC } from "react";

export const StepCircleInactive: FC<SvgIconProps> = ({ width = 32, height = 32, stroke = 'var(--light-gray)' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke={stroke} />
    </svg>
  );
};
